// extracted by mini-css-extract-plugin
export default {"icon":"e6zB3","isActive":"gdIkG","hasShadow":"aTawV","onDark":"_5kWA3","hasHover":"GKhsB","shape":"cQeXH","border":"ze-1u","onLight":"-TEfF","skeleton-progress":"vFcrU"};